module.exports = __webpack_public_path__ + "media/tto/bghead-d7974e57.png";